import React, { Component } from "react";
import { withRouter, NavLink } from "react-router-dom";
import { connect } from "react-redux";
import {
  showMedicalRecord,
  pdfGeneratorStatus,
} from "../../actions/medicalRecords";
import { PDFExport } from "@progress/kendo-react-pdf";
import HeaderTemplate from "../../pages/medical-records/view/header.js";
import { BASE_URL } from "../../utils/helper";

async function toDataURL(src, callback) {
  var img = new Image();
  img.crossOrigin = "Anonymous";
  img.onload = function () {
    var canvas = document.createElement("CANVAS");
    var ctx = canvas.getContext("2d");
    var dataURL;
    canvas.height = this.naturalHeight;
    canvas.width = this.naturalWidth;
    ctx.drawImage(this, 0, 0);
    dataURL = canvas.toDataURL("image/png");
    callback(dataURL);
  };

  let imgscr = src + "?t=" + Math.floor(Math.random() * 10000);

  img.src = imgscr;
  if (img.complete || img.complete === undefined) {
    img.src =
      "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
    img.src = imgscr;
  }
}

class PDFView extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    mRecord: {
      Breed: {},
      Pet: {},
      Registration_type: {},
      Breeder: {},
      MedicalRecordMedications: [],
    },
    bannerDone: "",
    sending: false,
  };

  componentDidMount() {
    this.props.setClick(this.exportPDF);
  }

  componentWillReceiveProps = (nextProps) => {
    if (
      nextProps.data.medicalRecordsReducer.printMRecord &&
      this.props.data.medicalRecordsReducer.printMRecord !==
      nextProps.data.medicalRecordsReducer.printMRecord
    ) {
      this.setState({
        mRecord: nextProps.data.medicalRecordsReducer.printMRecord,
      });
    }

    //     if(this.props.data.medicalRecordsReducer.showRecord !== nextProps.data.medicalRecordsReducer.showRecord) {
    // 	   this.setState({
    // 		   mRecord: nextProps.data.medicalRecordsReducer.showRecord,
    // 		   BreederId: (nextProps.data.medicalRecordsReducer.showRecord.Breeder) ? nextProps.data.medicalRecordsReducer.showRecord.Breeder.id : null,

    // 	   });
    // 	   if(nextProps.data.medicalRecordsReducer.showRecord.mc_status === "draft"){
    // 		   this.setState({recordCompleted:false});
    // 	   }
    //    }
  };

  // async componentDidUpdate(prevProps, prevState) {
  //   try{
  //     if (
  //       this.state.bannerDone &&
  //       this.props.data.medicalRecordsReducer.printMRecord
  //     ) {
  //       await this.resume.save();
  //       // this.dismiss();
  //     }
  //   } catch (e) {
  //     console.error("Problem", e)
  //   }

  // }

  exportPDF = async () => {
    var _self = this;
    _self.props.pdfGeneratorStatus(true);

    _self.path =
      process.env.REACT_APP_S3_PATH +
      "/" +
      this.props.petShop.currentPetshop.logo_path;
    if (this.props.petShop.currentPetshop.logo_path) {
      toDataURL(_self.path, async function (dataUrl) {
        _self.setState({ sending: false });
        _self.setState({ bannerDone: dataUrl });

        try {
          await _self.resume.save();
          _self.props.pdfGeneratorStatus(false);
        } catch (e) {
          console.error("Problem", e);
        }
      });
    } else {
      try {
        await _self.resume.save();
        _self.props.pdfGeneratorStatus(false);
      } catch (e) {
        console.error("Problem", e);
      }
    }
    //
  };

  render() {
    const { mRecord, bannerDone } = this.state;
    const { petShop } = this.props;  
    let filename = mRecord.pet_id +"_MedicalRecord"

    return (
      <div style={{ position: "absolute", top: "0px", left: "-1500px" }}>
        <PDFExport
          paperSize="Letter"
          forceProxy={true}
          proxyURL={BASE_URL + "/public/pet_shop/proxyDownload"}
          proxyTarget="_blank"
          keepTogether=".sign"
          margin="0.25cm"
          fileName={filename}
          title=""
          subject=""
          keywords=""
          landscape={true}
          ref={(component) => (this.resume = component)}
        >
          {mRecord.pet_id ? (
            <div
              className="container"
              style={{
                width: "100%",
                background: "#fff",
                fontSize: "9px",
                textTransform: "uppercase",
              }}
            >
              <div className="header-wrapper">
                <div
                  className="logo-section"
                  style={{ width: "330px", float: "left", marginTop: "12px" }}
                >
                  <img className="m-height-48 m-width-250" src={bannerDone} />
                </div>
                <div
                  className="brand-section"
                  style={{
                    width: "242px",
                    float: "right",
                    textAlign: "center",
                    marginLeft: "50px",
                    paddingTop: "8px",
                    fontSize: "21px",
                  }}
                >
                  PET MEDICAL RECORD
                  <div
                    className="info-section"
                    style={{ fontSize: "10px", float: "right", width: "100%" }}
                  >
                    <div className="arrival-info" style={{ float: "left" }}>
                      ARRIVAL:{" "}
                      <span style={{ fontWeight: "normal" }}>
                        {mRecord.arrival_date}
                      </span>
                    </div>
                    <div className="pet-info" style={{ float: "right" }}>
                      PET ID#:{" "}
                      <span style={{ fontWeight: "normal" }}>
                        {mRecord.pet_id}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clear" style={{ clear: "both" }}></div>
              <div className="wrapper" style={{ padding: "5px 0" }}>
                <div
                  className="box-one"
                  style={{
                    width: "242px",
                    padding: "0 10px",
                    backgroundColor: "#f0f2e7",
                    float: "left",
                    minHeight: "180px",
                    marginRight: "10px",
                    borderRadius: "25px",
                  }}
                >
                  <div
                    className="title-box"
                    style={{ verticalAlign: "middle", marginTop: "10px" }}
                  >
                    <img
                      src="../assets/app/media/img/icons/pet-ico.png"
                      className="ico"
                    />
                    <h5
                      style={{
                        color: "#000",
                        float: "left",
                        margin: "10px 0",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      PET
                    </h5>
                  </div>
                  <div className="clear" style={{ clear: "both" }}></div>
                  <h6
                    style={{
                      borderBottom: "1px dotted #000",
                      fontWeight: "bold",
                      fontSize: "9px",
                      margin: "8px 0",
                    }}
                  >
                    SEX:{" "}
                    <span style={{ fontWeight: "normal" }}>{mRecord.sex}</span>
                  </h6>
                  <h6
                    style={{
                      borderBottom: "1px dotted #000",
                      fontWeight: "bold",
                      fontSize: "9px",
                      margin: "8px 0",
                    }}
                  >
                    BREED:{" "}
                    <span style={{ fontWeight: "normal" }}>
                      {mRecord.breed_type}
                    </span>
                  </h6>
                  <h6
                    style={{
                      borderBottom: "1px dotted #000",
                      fontWeight: "bold",
                      fontSize: "9px",
                      margin: "8px 0",
                    }}
                  >
                    COLOR:{" "}
                    <span style={{ fontWeight: "normal" }}>
                      {mRecord.color_markings}
                    </span>
                  </h6>
                  <h6
                    style={{
                      borderBottom: "1px dotted #000",
                      fontWeight: "bold",
                      fontSize: "9px",
                      margin: "8px 0",
                    }}
                  >
                    DATE OF BIRTH:{" "}
                    <span style={{ fontWeight: "normal" }}>
                      {mRecord.date_of_birth}
                    </span>
                  </h6>
                  <h6
                    style={{
                      borderBottom: "1px dotted #000",
                      fontWeight: "bold",
                      fontSize: "9px",
                      margin: "8px 0",
                    }}
                  >
                    MICROCHIP #:{" "}
                    <span style={{ fontWeight: "normal" }}>
                      {mRecord.micro_chip}
                    </span>
                  </h6>
                  <h6
                    style={{
                      borderBottom: "1px dotted #000",
                      fontWeight: "bold",
                      fontSize: "9px",
                      margin: "8px 0",
                    }}
                  >
                    CROSS BREED:{" "}
                    <span style={{ fontWeight: "normal" }}>
                      {mRecord.cross_breed}
                    </span>
                  </h6>
                </div>

                <div
                  className="box-two"
                  style={{
                    width: "242px",
                    padding: "0 10px",
                    backgroundColor: "#f0f2e7",
                    float: "left",
                    minHeight: "180px",
                    marginRight: "10px",
                    borderRadius: "25px",
                  }}
                >
                  <div
                    className="title-box"
                    style={{ verticalAlign: "middle", marginTop: "10px" }}
                  >
                    <img
                      src="../assets/app/media/img/icons/register-ico.png"
                      className="ico"
                    />
                    <h5
                      style={{
                        color: "#000",
                        float: "left",
                        margin: "10px 0",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      REGISTRATION
                    </h5>
                  </div>
                  <div className="clear" style={{ clear: "both" }}></div>
                  <h6
                    style={{
                      borderBottom: "1px dotted #000",
                      fontWeight: "bold",
                      fontSize: "9px",
                      margin: "8px 0",
                    }}
                  >
                    REGISTRATION TYPE:{" "}
                    <span style={{ fontWeight: "normal" }}>
                      {mRecord.reg_type}
                    </span>
                  </h6>
                  <h6
                    style={{
                      borderBottom: "1px dotted #000",
                      fontWeight: "bold",
                      fontSize: "9px",
                      margin: "8px 0",
                    }}
                  >
                    SIRE:{" "}
                    <span style={{ fontWeight: "normal" }}>{mRecord.sire}</span>
                  </h6>
                  <h6
                    style={{
                      borderBottom: "1px dotted #000",
                      fontWeight: "bold",
                      fontSize: "9px",
                      margin: "8px 0",
                    }}
                  >
                    DAM:{" "}
                    <span style={{ fontWeight: "normal" }}>{mRecord.dam}</span>
                  </h6>
                  <h6
                    style={{
                      borderBottom: "1px dotted #000",
                      fontWeight: "bold",
                      fontSize: "9px",
                      margin: "8px 0",
                    }}
                  >
                    REGISTRATION NO SIRE:{" "}
                    <span style={{ fontWeight: "normal" }}>
                      {mRecord.sire_number}
                    </span>
                  </h6>
                  <h6
                    style={{
                      borderBottom: "1px dotted #000",
                      fontWeight: "bold",
                      fontSize: "9px",
                      margin: "8px 0",
                    }}
                  >
                    REGISTRATION NO DAM:{" "}
                    <span style={{ fontWeight: "normal" }}>
                      {mRecord.dam_number}
                    </span>
                  </h6>
                </div>
                <div
                  className="box-three"
                  style={{
                    width: "242px",
                    padding: "0 10px",
                    backgroundColor: "#f0f2e7",
                    float: "left",
                    minHeight: "180px",
                    borderRadius: "25px",
                  }}
                >
                  <div
                    className="title-box"
                    style={{ verticalAlign: "middle", marginTop: "10px" }}
                  >
                    <img
                      src="../assets/app/media/img/icons/man-ico.png"
                      className="ico"
                    />
                    <h5
                      style={{
                        color: "#000",
                        float: "left",
                        margin: "10px 0",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      BREEDER
                    </h5>
                  </div>
                  <div className="clear" style={{ clear: "both" }}></div>
                  <h6
                    style={{
                      borderBottom: "1px dotted #000",
                      fontWeight: "bold",
                      fontSize: "9px",
                      margin: "8px 0",
                    }}
                  >
                    BREEDER:{" "}
                    <span style={{ fontWeight: "normal" }}>
                      {mRecord.Breeder && mRecord.Breeder.breeder
                        ? mRecord.Breeder.breeder
                        : "-"}
                    </span>
                  </h6>
                  <h6
                    style={{
                      borderBottom: "1px dotted #000",
                      fontWeight: "bold",
                      fontSize: "9px",
                      margin: "8px 0",
                    }}
                  >
                    BREEDER ADDRESS:{" "}
                    <span style={{ fontWeight: "normal" }}>
                      {mRecord.Breeder && mRecord.Breeder.addressLine1
                        ? mRecord.Breeder.addressLine1
                        : "-"}
                      {mRecord.Breeder && mRecord.Breeder.addressLine2
                        ? ", " + mRecord.Breeder.addressLine2
                        : ""}
                      {mRecord.Breeder && mRecord.Breeder.addressCity
                        ? ", " + mRecord.Breeder.addressCity
                        : ""}
                      {mRecord.Breeder && mRecord.Breeder.addressState
                        ? ", " + mRecord.Breeder.addressState
                        : ""}
                      {mRecord.Breeder && mRecord.Breeder.addressPostalCode
                        ? ", " + mRecord.Breeder.addressPostalCode
                        : ""}
                      {mRecord.Breeder && mRecord.Breeder.addressCountry
                        ? ", " + mRecord.Breeder.addressCountry
                        : ""}
                    </span>
                  </h6>
                  <h6
                    style={{
                      borderBottom: "1px dotted #000",
                      fontWeight: "bold",
                      fontSize: "9px",
                      margin: "8px 0",
                    }}
                  >
                    USDA #:{" "}
                    <span style={{ fontWeight: "normal" }}>
                      {mRecord.Breeder && mRecord.Breeder.usda_no
                        ? mRecord.Breeder.usda_no
                        : "-"}
                    </span>
                  </h6>
                </div>
              </div>

              <div className="wrapper" style={{ padding: "10px 0" }}>
                <div
                  className="box-one"
                  style={{
                    width: "368px",
                    padding: "0 10px",
                    backgroundColor: "#f0f2e7",
                    minHeight: "285px",
                    marginRight: "10px",
                    marginTop: "10px",
                    float: "left",
                    borderRadius: "25px",
                  }}
                >
                  <div
                    className="title-box"
                    style={{ verticalAlign: "middle", marginTop: "10px" }}
                  >
                    <img
                      src="../assets/app/media/img/icons/info-ico.png"
                      className="ico"
                    />
                    <h5
                      style={{
                        color: "#000",
                        float: "left",
                        margin: "10px 0",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      VACCINATIONS
                    </h5>
                  </div>
                  <div className="clear" style={{ clear: "both" }}></div>
                  <table
                    width="100%"
                    border="0"
                    cellSpacing="0"
                    cellPadding="0"
                  ><thead></thead>
                    <tbody>
                      <tr>
                        <td
                          style={{
                            lineHeight: "14px",
                            color: "#252424",
                            fontSize: "9px",
                            fontWeight: 600,
                            paddingTop: "10px",
                            textTransform: "uppercase",
                          }}
                        >
                          <table
                            width="100%"
                            border="0"
                            cellSpacing="0"
                            cellPadding="0"
                          >
                            <thead>
                              <tr>
                                <td
                                  style={{
                                    fontWeight: 600,
                                    fontSize: "9px",
                                    borderBottom: "1px dotted #555555",
                                    textAlign: "left",
                                    padding: "3px 0 3px 5px",
                                    backgroundColor: "#e6e6e6",
                                  }}
                                >
                                  Week of
                                </td>
                                <td
                                  style={{
                                    fontWeight: 600,
                                    fontSize: "9px",
                                    borderBottom: "1px dotted #555555",
                                    textAlign: "left",
                                    padding: "3px 0 3px 5px",
                                    backgroundColor: "#e6e6e6",
                                  }}
                                >
                                  Vaccinations
                                </td>
                                <td
                                  style={{
                                    fontWeight: 600,
                                    fontSize: "9px",
                                    borderBottom: "1px dotted #555555",
                                    textAlign: "left",
                                    padding: "3px 0 3px 5px",
                                    backgroundColor: "#e6e6e6",
                                  }}
                                >
                                  More info
                                </td>
                              </tr>
                            </thead>
                            <tbody>
                              {mRecord.MedicalRecordMedications.length > 0
                                ? mRecord.MedicalRecordMedications.filter(
                                  (i) => {
                                    return i.Medication.type === "vaccine";
                                  }
                                ).map((item, index) => (
                                  <tr>
                                    <td
                                      style={{
                                        fontWeight: 400,
                                        fontSize: "9px",
                                        borderBottom: "1px dotted #555555",
                                        textAlign: "left",
                                        width: "125px",
                                        padding: "3px 0 3px 5px",
                                        backgroundColor: "#f5f5f5",
                                      }}
                                    >
                                      {item.date}
                                    </td>
                                    <td
                                      style={{
                                        fontWeight: 400,
                                        fontSize: "9px",
                                        borderBottom: "1px dotted #555555",
                                        textAlign: "left",
                                        width: "367px",
                                        padding: "3px 0 3px 5px",
                                        backgroundColor: "#f5f5f5",
                                      }}
                                    >
                                      {item.Medication.name}
                                    </td>
                                    <td
                                      style={{
                                        fontWeight: 400,
                                        fontSize: "9px",
                                        borderBottom: "1px dotted #555555",
                                        textAlign: "left",
                                        width: "367px",
                                        padding: "3px 0 3px 5px",
                                        backgroundColor: "#f5f5f5",
                                      }}
                                    >
                                      {item.more_info}
                                    </td>
                                  </tr>
                                ))
                                : ""}
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  className="box-two"
                  style={{
                    width: "368px",
                    padding: "0 10px",
                    backgroundColor: "#f0f2e7",
                    minHeight: "285px",
                    float: "left",
                    marginTop: "10px",
                    borderRadius: "25px",
                  }}
                >
                  <div
                    className="title-box"
                    style={{ verticalAlign: "middle", marginTop: "10px" }}
                  >
                    <img
                      src="../assets/app/media/img/icons/info-ico.png"
                      className="ico"
                    />
                    <h5
                      style={{
                        color: "#000",
                        float: "left",
                        margin: "10px 0",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      TREATMENTS
                    </h5>
                  </div>
                  <div className="clear" style={{ clear: "both" }}></div>
                  <table
                    width="100%"
                    border="0"
                    cellSpacing="0"
                    cellPadding="0"
                  >
                    <tbody>
                      <tr>
                        <td
                          style={{
                            lineHeight: "14px",
                            color: "#252424",
                            fontSize: "11px",
                            fontWeight: 600,
                            paddingTop: "10px",
                            textTransform: "uppercase",
                          }}
                        >
                          <table
                            width="100%"
                            border="0"
                            cellSpacing="0"
                            cellPadding="0"
                          >
                            <tbody>
                              <tr>
                                <td
                                  style={{
                                    fontWeight: 600,
                                    fontSize: "9px",
                                    borderBottom: "1px dotted #555555",
                                    textAlign: "left",
                                    padding: "3px 0 3px 5px",
                                    backgroundColor: "#e6e6e6",
                                  }}
                                >
                                  Week of
                                </td>
                                <td
                                  style={{
                                    fontWeight: 600,
                                    fontSize: "9px",
                                    borderBottom: "1px dotted #555555",
                                    textAlign: "left",
                                    padding: "3px 0 3px 5px",
                                    backgroundColor: "#e6e6e6",
                                  }}
                                >
                                  Deworming
                                </td>
                                <td
                                  style={{
                                    fontWeight: 600,
                                    fontSize: "9px",
                                    borderBottom: "1px dotted #555555",
                                    textAlign: "left",
                                    padding: "3px 0 3px 5px",
                                    backgroundColor: "#e6e6e6",
                                  }}
                                >
                                  More info
                                </td>
                              </tr>
                              {mRecord.MedicalRecordMedications.length > 0
                                ? mRecord.MedicalRecordMedications.filter(
                                  (i) => {
                                    return i.Medication.type === "deworm";
                                  }
                                ).map((item, index) => (
                                  <tr>
                                    <td
                                      style={{
                                        fontWeight: 400,
                                        fontSize: "9px",
                                        borderBottom: "1px dotted #555555",
                                        textAlign: "left",
                                        width: "125px",
                                        padding: "3px 0 3px 5px",
                                        backgroundColor: "#f5f5f5",
                                      }}
                                    >
                                      {item.date}
                                    </td>
                                    <td
                                      style={{
                                        fontWeight: 400,
                                        fontSize: "9px",
                                        borderBottom: "1px dotted #555555",
                                        textAlign: "left",
                                        width: "367px",
                                        padding: "3px 0 3px 5px",
                                        backgroundColor: "#f5f5f5",
                                      }}
                                    >
                                      {item.Medication.name}
                                    </td>
                                    <td
                                      style={{
                                        fontWeight: 400,
                                        fontSize: "9px",
                                        borderBottom: "1px dotted #555555",
                                        textAlign: "left",
                                        width: "367px",
                                        padding: "3px 0 3px 5px",
                                        backgroundColor: "#f5f5f5",
                                      }}
                                    >
                                      {item.more_info}
                                    </td>
                                  </tr>
                                ))
                                : ""}
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="clear" style={{ clear: "both" }}></div>
              <div className="notes-section" style={{ marginTop: "10px" }}>
                <table width="100%" border="0" cellSpacing="0" cellPadding="0">
                  <thead></thead>
                  <tbody>
                    <tr>
                      <td
                        colSpan="8"
                        style={{
                          fontWeight: "bold",
                          fontSize: "12px",
                          textAlign: "left",
                          display: "flex",
                        }}
                      >
                        Notes:
                        <span
                          style={{
                            fontWeight: "normal",
                            fontSize: "9px",
                            borderBottom: "1px dotted #000",
                            padding: "5px 0 0 10px",
                            width: "100%",
                          }}
                        >
                          {mRecord.notes}
                        </span>
                      </td>
                      {/* <td colspan="8" style={{fontWeight:'normal', fontSize:'9px', borderBottom:'1px dotted #000', padding:'5px 0 5px 10px'}}>{mRecord.notes}</td> */}
                    </tr>
                    {/* <tr>
												<td colspan="8" style={{fontWeight:400, fontSize:'11px', borderTop:'1px dotted #000', padding:'5px 0 5px 10px'}}>&nbsp;</td>
											</tr>
											<tr>
												<td colspan="8" style={{fontWeight:400, fontSize:'11px', borderTop:'1px dotted #000', padding:'5px 0 5px 10px'}}>&nbsp;</td>
											</tr> */}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
              ""
            )}
        </PDFExport>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  petShop: state.petShopReducer,
  user: state.cognito.user,
  data: state,
});

const mapDispatchToProps = (dispatch) => ({
  showMedicalRecord: (id) => {
    dispatch(showMedicalRecord(id));
  },
  pdfGeneratorStatus: (status) => {
    dispatch(pdfGeneratorStatus(status));
  },
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PDFView)
);
